import { render, staticRenderFns } from "./WorkingHours.vue?vue&type=template&id=1958e6d2&scoped=true&"
import script from "./WorkingHours.vue?vue&type=script&lang=js&"
export * from "./WorkingHours.vue?vue&type=script&lang=js&"
import style0 from "./WorkingHours.vue?vue&type=style&index=0&id=1958e6d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1958e6d2",
  null
  
)

export default component.exports